import { defineFcm } from '../shared/factory';

export const FCM_ENGAGEMENT_PWA_ENABLED = defineFcm('engagement_pwa_enabled').asBoolean().withDefault(false).toConfig();
